export default { sha: '6698faa9275a98c8d5b7ac19ff7a025a8a345296', buildNumber: 'undefined' }
